import React from "react";
import ContentLoader from "react-content-loader";
import DateRangeInput from "./DateRangeInput";
import { toggleEventStatus, useGetEvents } from "../services/CreateurService";
import { Heart, Eye, Plus, Edit, Activity, Calendar } from "lucide-react";
import Lottie from "lottie-react";
import nodata from "../assets/nodata.json";
import { MdAddCircle } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const EventCardPlaceholder = () => (
    <ContentLoader
        viewBox="0 0 400 320"
        backgroundColor="#f0f0f0"
        foregroundColor="#dedede"
        className="w-full h-[260px] rounded-2xl"
    >
        <rect x="0" y="0" rx="10" ry="10" width="400" height="180" />
        <rect x="8" y="196" rx="4" ry="4" width="220" height="18" />
        <rect x="8" y="222" rx="3" ry="3" width="160" height="14" />
        <rect x="8" y="260" rx="3" ry="3" width="380" height="14" />
    </ContentLoader>
);

const MesEvents = () => {
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");
    const navigate = useNavigate();

    const {
        events,
        loading,
        pagination,
        search,
        setSearch,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        sort,
        setSort,
        order,
        setOrder,
        fetchEvents,
        setEvents,
    } = useGetEvents();

    const handlePageChange = (newPage) => {
        if (newPage < 1 || newPage > pagination.last_page) return; // sécurité
        fetchEvents(newPage); // charger la page

        // 🔹 Scroll vers la grille des événements
        const grid = document.getElementById("eventsGrid");
        if (grid) {
            grid.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };
    const handleDateChange = ({ startDate, endDate }) => {
        setStartDate(startDate);
        setEndDate(endDate);
        fetchEvents();
    };
    // Dans ton composant MesEvents, en haut
    const handleToggleEvent = async (even) => {
        //console.log("🔹 Toggle demandé pour l'événement :", even.id, "État actuel :", even.is_active);

        try {
            const data = await toggleEventStatus(even.id, token);
            //console.log("✅ Réponse API toggleEventStatus :", data);

            // Mise à jour locale directe
            even.is_active = data.is_active;
            //console.log("🔹 Nouvel état local is_active :", even.is_active);

            // Force le state pour rerender la grille
            setEvents((prevEvents) =>
                prevEvents.map((e) => (e.id === even.id ? { ...e, is_active: data.is_active } : e))
            );
        } catch (err) {
            console.error("❌ Erreur toggleEventStatus:", err);
        }
    };


    return (
        <div className="w-full flex justify-center pb-20 font-Poppins">
            <div className="w-full max-w-6xl space-y-6">
                {/* En-tête + ajout */}


                {/* Filtres */}
                {/* 🔹 Filtres */}
                <div id="eventsGrid" className="flex flex-col gap-3 w-full">

                    {/* Ligne 1 : Date + Reset */}
                    {/* Ligne 1 : Date + Ajouter + Reset */}
                    <div className="flex flex-row sm:flex-row sm:items-center sm:justify-between gap-4 w-full">

                        <DateRangeInput
                            initialStartDate={startDate}
                            initialEndDate={endDate}
                            onChange={handleDateChange}
                            title2="Filtrer par date :"
                        />

                        <div className="flex flex-row items-center gap-3">

                            <button
                                onClick={() => {
                                    setStartDate(null);
                                    setEndDate(null);
                                    setSearch("");
                                    setSort("date");
                                    setOrder("desc");
                                    fetchEvents(1);
                                }}
                                className="text-color1 font-medium hover:underline whitespace-nowrap"
                            >
                                Réinitialiser
                            </button>
                            <button
                                onClick={() => navigate('/EspaceClient/mesevents/ajouter')}
                                className="flex items-center gap-2 bg-color1 text-white font-semibold px-5 py-2 rounded-xl hover:opacity-90 transition whitespace-nowrap"
                            >
                                <Plus size={20} /> Ajouter un événement
                            </button>

                        </div>

                    </div>

                    {/* Ligne 2 : Search et boutons tri */}
                    <div className="flex flex-wrap justify-between items-center gap-3 w-full">

                        {/* Search */}
                        <div className="relative flex-1">
                            <input
                                type="text"
                                placeholder="Rechercher par titre..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 pr-10 focus:ring-2 focus:ring-color1 outline-none"
                            />
                            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-4.35-4.35M16.65 16.65A7.5 7.5 0 1110.5 3a7.5 7.5 0 016.15 13.65z" />
                                </svg>
                            </span>
                        </div>

                        {/* Boutons tri */}
                        <div className="flex gap-2 flex-wrap">
                            {[
                                { key: "date", label: "Date", icon: <Calendar size={16} /> },
                                { key: "likes", label: "Likes", icon: <Heart size={16} /> },
                                { key: "views", label: "Vues", icon: <Eye size={16} /> },
                                { key: "clicks", label: "Clics", icon: <Activity size={16} /> },
                            ].map((btn) => (
                                <button
                                    key={btn.key}
                                    onClick={() => {
                                        if (sort === btn.key) {
                                            setOrder(order === "asc" ? "desc" : "asc");
                                        } else {
                                            setSort(btn.key);
                                            setOrder("desc");
                                        }
                                        fetchEvents(1);
                                    }}
                                    className={`flex items-center gap-1 px-4 py-2 rounded-xl font-medium text-sm transition
        ${sort === btn.key ? "bg-color1 text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"}`}
                                >
                                    {btn.icon}
                                    <span>{btn.label}</span>
                                    {sort === btn.key && (
                                        <span>
                                            {order === "asc" ? (
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                                                </svg>
                                            ) : (
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                </svg>
                                            )}
                                        </span>
                                    )}
                                </button>
                            ))}
                        </div>
                    </div>
                    {/* Pagination */}
                    {pagination.last_page > 1 && (
                        <div className="flex w-full justify-left items-left gap-3 mt-4">
                            <button
                                disabled={pagination.current_page === 1}
                                onClick={() => handlePageChange(pagination.current_page - 1)}
                                className={`px-4 py-1 rounded-lg text-white text-sm font-semibold ${pagination.current_page === 1 ? "bg-gray-400 cursor-not-allowed" : "bg-color1 hover:bg-color6 cursor-pointer"}`}
                            >
                                Précédent
                            </button>

                            <span className="text-color11 font-medium text-sm">
                                {pagination.current_page} / {pagination.last_page}
                            </span>

                            <button
                                disabled={pagination.current_page === pagination.last_page}
                                onClick={() => handlePageChange(pagination.current_page + 1)}
                                className={`px-4 py-1 rounded-lg text-white text-sm font-semibold ${pagination.current_page === pagination.last_page ? "bg-gray-400 cursor-not-allowed" : "bg-color1 hover:bg-color6 cursor-pointer"}`}
                            >
                                Suivant
                            </button>
                        </div>
                    )}
                </div>


                {/* Grille événements */}
                <>
                    {/* 🔹 Loading */}
                    {loading && (
                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                            {Array.from({ length: pagination?.per_page || 6 }).map((_, i) => (
                                <EventCardPlaceholder key={i} />
                            ))}
                        </div>
                    )}



                    {/* 🔹 Grille des événements */}
                    {!loading && events && events.length > 0 && (
                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                            {events.map((even) => {
                                const date = new Date(even.dateEven || even.date);
                                const jours = ["Lun.", "Mar.", "Mer.", "Jeu.", "Ven.", "Sam.", "Dim."];
                                const mois = [
                                    "JAN.", "FÉV.", "MAR.", "AVR.", "MAI", "JUIN",
                                    "JUIL.", "AOÛ.", "SEP.", "OCT.", "NOV.", "DÉC."
                                ];
                                const jourNom = jours[date.getDay() === 0 ? 6 : date.getDay() - 1];
                                const jourNum = date.getDate().toString().padStart(2, "0");
                                const moisNom = mois[date.getMonth()];
                                const annee = date.getFullYear();
                                const heure = `${date.getHours().toString().padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;

                                return (
                                    <div key={even.id} className={`rounded-2xl overflow-hidden  shadow-md hover:shadow-xl transition-all duration-300 flex flex-col
                                        order-4 ${even.is_active ? "border-green-500" : "border-red-500 border-[2px] "}`}>
                                        {/* Image + date + actions */}
                                        <div className="relative">
                                            <img
                                                src={even.imgEven || even.img}
                                                alt={even.nomEven || even.title}
                                                className="w-full h-36 sm:h-40 object-cover"
                                            />

                                            {/* Date en haut gauche */}
                                            <div className="absolute top-2 left-2 bg-black/60 text-white px-2 py-0.5 rounded-lg text-[10px] leading-tight flex flex-col text-center shadow">
                                                <span>{jourNom}</span>
                                                <span>{`${jourNum} ${moisNom}`}</span>
                                                <span>{annee}</span>
                                                <span>{heure}</span>
                                            </div>

                                            {/* 🔹 Bouton Edit en top-right */}
                                            <div className="absolute top-2 right-2 flex flex-col gap-1.5">
                                                {/* Edit */}
                                                <button
                                                    className="bg-white/80 hover:bg-white text-gray-800 p-1.5 rounded-full shadow"
                                                    onClick={() => navigate(`/EspaceClient/mesevents/update/${even.id}`)}
                                                >
                                                    <Edit size={15} />
                                                </button>

                                                {/* Voir / ouvrir */}
                                                <button
                                                    className="bg-white/80 hover:bg-white text-gray-800 p-1.5 rounded-full shadow"
                                                    onClick={() => navigate(`/EspaceClient/mesevents/view/${even.id}`)}
                                                >
                                                    <Eye size={15} />
                                                </button>
                                            </div>

                                            {/* 🔹 Bouton Activer/Désactiver en bottom-right */}
                                            <button
                                                onClick={() => handleToggleEvent(even)}
                                                className={`absolute bottom-2 right-2 px-2 py-0.5 rounded-lg text-white font-semibold text-[11px] transition
                                                ${even.is_active ? "bg-gray-500 hover:bg-gray-600" : "bg-green-500 hover:bg-green-600"}`}
                                            >
                                                {even.is_active ? "Désactiver" : "Activer"}
                                            </button>



                                        </div>


                                        {/* Texte */}
                                        <div className="p-3 flex flex-col flex-1">
                                            <h3 className="font-bold text-sm text-gray-800 truncate">{even.nomEven || even.title}</h3>
                                            <p className="text-xs text-gray-500 italic mb-1.5 truncate">{even.sousNomEven || even.subtitle || ""}</p>
                                            <div
                                                className="text-xs text-gray-600 line-clamp-2 mb-2"
                                                dangerouslySetInnerHTML={{ __html: even.description }}
                                            />

                                            {/* Footer stats */}
                                            <div className="flex justify-between items-center text-[11px] text-gray-600 border-t border-gray-200 pt-1.5 mt-auto">
                                                <span className="flex items-center gap-1" title="Likes">
                                                    <Heart size={13} className="text-pink-500" /> {even.nbr_jaime || 0}
                                                </span>
                                                <span className="flex items-center gap-1" title="Vues">
                                                    <Eye size={13} className="text-blue-500" /> {even.nbr_vues || 0}
                                                </span>
                                                <span className="flex items-center gap-1" title="Clics">
                                                    <Activity size={13} className="text-yellow-500" /> {even.nbr_clicks || 0}
                                                </span>
                                            </div>

                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}



                    {/* 🔹 Aucun événement trouvé */}
                    {/* 🔹 Aucun événement trouvé */}
                    {!loading && events !== null && events.length === 0 && (
                        <div className="flex flex-col items-center justify-center py-10 gap-3">
                            <Lottie animationData={nodata} loop className="w-40 h-40" />
                            <span className="text-gray-600 font-medium text-center">
                                Aucun événement trouvé
                            </span>
                            <a
                                href="/EspaceClient/mesevents/ajouter"
                                className="mt-2 bg-color4 text-white font-semibold px-5 py-2 rounded-xl shadow hover:bg-color6 transition-colors flex items-center gap-2"
                            >
                                <MdAddCircle size={20} />
                                Ajouter un événement
                            </a>
                        </div>
                    )}

                </>



                {/* Pagination */}
                {pagination.last_page > 1 && (
                    <div className="flex w-full justify-left items-left gap-3 mt-4">
                        <button
                            disabled={pagination.current_page === 1}
                            onClick={() => handlePageChange(pagination.current_page - 1)}
                            className={`px-4 py-1 rounded-lg text-white text-sm font-semibold ${pagination.current_page === 1 ? "bg-gray-400 cursor-not-allowed" : "bg-color1 hover:bg-color6 cursor-pointer"}`}
                        >
                            Précédent
                        </button>

                        <span className="text-color11 font-medium text-sm">
                            {pagination.current_page} / {pagination.last_page}
                        </span>

                        <button
                            disabled={pagination.current_page === pagination.last_page}
                            onClick={() => handlePageChange(pagination.current_page + 1)}
                            className={`px-4 py-1 rounded-lg text-white text-sm font-semibold ${pagination.current_page === pagination.last_page ? "bg-gray-400 cursor-not-allowed" : "bg-color1 hover:bg-color6 cursor-pointer"}`}
                        >
                            Suivant
                        </button>
                    </div>
                )}
            </div>
        </div >
    );
};

export default MesEvents;